function zoomImage(e) {
  var a = e.src;
  (document.getElementById("zoomedImg").src = a),
    (document.getElementById("zoomimg").style.display = "flex");
}
function closeZoom() {
  document.getElementById("zoomimg").style.display = "none";
}
$(document).ready(function () {
  var e = $("#big"),
    a = $("#thumbs");
  e
    .owlCarousel({
      items: 1,
      slideSpeed: 2e3,
      nav: !0,
      autoplay: !1,
      dots: !1,
      loop: !0,
      responsiveRefreshRate: 200,
      navText: [
        '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
        '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
      ],
    })
    .on("changed.owl.carousel", function e(i) {
      var t = i.item.count - 1,
        o = Math.round(i.item.index - i.item.count / 2 - 0.5);
      o < 0 && (o = t),
        o > t && (o = 0),
        a.find(".owl-item").removeClass("current").eq(o).addClass("current");
      var n = a.find(".owl-item.active").length - 1,
        l = a.find(".owl-item.active").first().index();
      o > a.find(".owl-item.active").last().index() &&
        a.data("owl.carousel").to(o, 100, !0),
        o < l && a.data("owl.carousel").to(o - n, 100, !0);
    }),
    a
      .on("initialized.owl.carousel", function () {
        a.find(".owl-item").eq(0).addClass("current");
      })
      .owlCarousel({
        items: 7,
        dots: !1,
        nav: !0,
        navText: [
          '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
          '<i class="fa fa-chevron-right" aria-hidden="true"></i>',
        ],
        smartSpeed: 200,
        slideSpeed: 500,
        slideBy: 1,
        responsiveRefreshRate: 100,
      })
      .on("changed.owl.carousel", function a(i) {
        var t = i.item.index;
        e.data("owl.carousel").to(t, 100, !0);
      }),
    a.on("click", ".owl-item", function (a) {
      a.preventDefault();
      var i = $(this).index();
      e.data("owl.carousel").to(i, 300, !0);
    });
});
